import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import APIS from "../../../../../constant/Endpoint";
import { getApiData } from "../../../../../helpers/AxiosInstance";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  const blogResponse = await getApiData(APIS.BLOG, {});
  const blogCatResponse = await getApiData(APIS.BLOG_CATEGORY, {});
  const blogAuthorResponse = await getApiData(APIS.AUTHOR, {});
  const blogTagResponse = await getApiData(APIS.TAG, {});

  Components.addType("blog-list", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("blogList")
      ) {
        return {
          type: "blog-list",
        };
      }
    },
    model: {
      defaults: {
        traits: [
          {
            type: "select",
            label: "Type",
            name: "type",
            options: [
              { id: "category", name: "Category" },
              { id: "author", name: "Author" },
              { id: "tag", name: "Tag" },
              { id: "similar", name: "Similar" },
            ],
          },
          {
            type: "select",
            label: "Category",
            name: "category",
            options: blogCatResponse?.data ?? [],
          },
          {
            type: "select",
            label: "Author",
            name: "author",
            options: blogAuthorResponse?.data ?? [],
          },
          {
            type: "select",
            label: "Tag",
            name: "tag",
            options: blogTagResponse?.data ?? [],
          },
          {
            type: "select",
            label: "Blog",
            name: "blog",
            options: blogResponse?.data ?? [],
          },
        ],
        components: /*html*/ `
          <section class="md:my-10 mt-4 blogList">

            <div class="container mx-auto px-4">
              <div
                class="flex items-center justify-between mx-3 md:mx-0 md:mb-6 mb-3 "
              >
                <div class="flex items-center gap-x-2">
                  <div
                    class="border-s-4 border-[var(--primary)] md:h-7 h-5 relative"
                  ></div>
                  <h2
                    class="text-xl font-medium md:font-semibold font-montserrat md:text-3xl"
                  >
                    Latest from blog
                  </h2>
                </div>
                <a href="/#" class="md:hidden">
                  <p class="text-[var(--primary)]">See All</p>
                </a>
              </div>
              <div
                class="grid grid-cols-1 gap-x-4 md:grid-cols-3 xl:grid-cols-4 md:gap-x-10 xl:gap-x-16 gap-y-6"
              >
                  <!-- {% blogs as blogs %} -->
                  <!-- {% for blog in blogs %} -->

                    <!-- {% comment %} -->
                <a href="/blog" class="p-2 ">
                      <!-- {% endcomment %} -->
                <!-- <a href="{{ blog.absolute_url }}" class="p-2"> -->

                  <div
                    class="bg-white border border-gray-300 rounded-lg overflow-hidden flex flex-col max-w-sm md:max-w-md lg:max-w-lg mx-auto shadow-lg ripple-effect relative overflow-hidden"
                  >


                    <div class="w-full">
                      <!-- {% comment %} -->
                      <img
                        src="https://via.placeholder.com/100"
                        alt="blog_img"
                        class="w-full h-48 object-cover"
                      />

                      <!-- {% endcomment %} -->

                        <!-- <img
                        src="{% generate_thumbnail blog.preview_image_url '325x300/filters:format(webp)' %}"
                        alt="{{ blog.headline }}"
                        class="w-full h-48 object-cover"
                      /> -->
                    </div>
                    <div class="p-4 md:p-6">
                      <div
                        class="flex items-center text-primary text-xs md:text-sm mb-2"
                      >
                        <span class="text-[var(--primary)]">
                            <!-- {% comment %} -->
                            Jan 06, 2025
                             <!-- {% endcomment %} -->

                            <!-- {{ blog.created | date:"b d, Y" | capfirst }} -->
                        </span>
                      </div>
                      <h3
                        class="text-base md:text-lg font-bold text-gray-800 mb-1 md:mb-2"
                      >
                            <!-- {% comment %} -->
                            Scam Alert
                             <!-- {% endcomment %} -->
                        <!-- {{ blog.headline|title }}  -->

                      </h3>
                      <p class="text-gray-600 text-sm md:text-base mb-2 ">
                          <!-- {% comment %} -->
                          E-commerce Scam Alert: Stay Safe While Shopping Online
                          <!-- {% endcomment %} -->
                      </p>
                      <button
                        href="/blogdetail"
                        class="text-black text-xs md:text-sm
                        font-semibold uppercase border-b-2 border-black
                        hover:text-primary hover:border-transparent
                        transition-all duration-300"
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                </a>
                  <!-- {% endfor %} -->
              </div>
              <div class="flex w-full justify-center mt-4">
                <button class="text-red-400">Load More...</button>
              </div>
              <hr class=" my-2 border-gray-400" />
            </div>
          </section>
        `,
      },
    },
  });
};
